import call11 from "../../assets/images/call11.svg";
import mail_track from "../../assets/images/mail_track.svg";
import location_1 from "../../assets/images/location_1.svg";
import fb11 from "../../assets/images/fb_11.webp";
import you11 from "../../assets/images/you11.svg";
import tik11 from "../../assets/images/tik11.svg";
import FormInput from "./FormInput";

export default function ContactHead() {
  return (
    <div className="bg-white w-full">
      <div className="w-full pt-24 container mx-auto p-3 flex flex-col gap-5  md:flex-col lg:flex-col ">
        <div>
          <p className="text-[28px] text-[#033F6A] font-semibold lg:text-center">
            Liên hệ với chúng tôi ngay hôm nay
          </p>
        </div>
        <div>
          <p className="text-[16px] font-normal text-[#606060] lg:text-center">
            Hãy để lại thông tin, đội ngũ chuyên gia của chúng tôi sẽ liên hệ và
            tư vấn giải pháp phù hợp nhất cho doanh nghiệp của bạn. Chúng tôi
            luôn sẵn sàng lắng nghe và hỗ trợ bạn trên hành trình phát triển và
            thành công.
          </p>
        </div>
        <div className="flex w-full flex-col gap-6 md:flex-col lg:flex-row md:items-center lg:items-center md:justify-between lg:justify-between">
          <div className="flex flex-row items-center gap-3 shadow-custom px-[12px] py-[8px] lg:w-1/4 md:w-full lg:h-[94px]">
            <div className="w-12 h-12 flex items-center justify-center bg-[#1C9BDB] rounded-[4px]">
              <img src={call11} alt="call" />
            </div>
            <div className="flex flex-col">
              <p className="text-[#1F1F1F] text-[16px] font-semibold">
                Hotline liên hệ
              </p>
              <p className="text-[16px] font-normal text-[#606060]">
                0968.596.859
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center gap-3 shadow-custom px-[12px] py-[8px] lg:w-1/4 md:w-full lg:h-[94px]">
            <div className="w-12 h-12 flex items-center justify-center bg-[#259D20] rounded-[4px]">
              <img src={mail_track} alt="mail" />
            </div>
            <div className="flex flex-col">
              <p className="text-[#1F1F1F] text-[16px] font-semibold">
                Địa chỉ email
              </p>
              <p className="text-[16px] font-normal text-[#606060]">
                lienhe@blueskyit.vn
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center gap-3 shadow-custom px-[12px] py-[8px] lg:w-1/4 md:w-full lg:h-[94px]">
            <div className="w-12 h-12 flex items-center justify-center bg-[#DB9D15] rounded-[4px]">
              <img src={location_1} alt="lo" />
            </div>
            <div className="flex flex-col">
              <p className="text-[#1F1F1F] text-[16px] font-semibold">
                Địa chỉ công ty
              </p>
              <p className="text-[16px] font-normal text-[#606060]">
                BT16B6 -32, Làng Việt Kiều Châu Âu, Mỗ Lao, Hà Đông, Hà Nội
              </p>
            </div>
          </div>
          <div className="shadow-custom px-[12px] py-[8px] flex flex-col gap-3 lg:w-1/4 md:w-full lg:h-[94px]">
            <div>
              <p className="text-[#1F1F1F] text-[16px] font-semibold">
                Theo dõi mạng xã hội
              </p>
            </div>
            <div className="flex flex-row items-center gap-4 ">
              <div>
                <img src={fb11} alt="" />
              </div>
              <div className="w-8 h-8 rounded-full bg-[#FF3F4F] flex items-center justify-center ">
                <img src={you11} alt="" />
              </div>
              <div className="w-9 h-9 rounded-full shadow-md flex items-center justify-center">
                <img src={tik11} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
